import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 355F6D86-E6B6-4EA4-91BA-95370240E9CF
 * name slash-forward
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/slash-forward.svg
 * tags
 * - Math 
 */
export const SlashForwardIcon = createSvgIcon(<><path d="M7 21L14.9 3H17L9.1 21H7Z" /></>, 'SlashForwardIcon');
export default SlashForwardIcon